if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


const prevArrowHTML =
    `<button class="slick-arrow slick-prev">
        <svg width="70" height="70" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="currentColor" stroke-width="1"><path vector-effect="non-scaling-stroke" d="M 30 25 L 20 35 L 30 45 M 20 35 H 50" /><circle vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" /><circle class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="2" /></svg>
        <span>Prev</span>
    </button>`;
const nextArrowtHTML =
    `<button class="slick-arrow slick-next">
        <span>Next</span>
        <svg width="70" height="70" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="currentColor" stroke-width="1"><path vector-effect="non-scaling-stroke" d="M 40 25 L 50 35 L 40 45 M 50 35 H 20" /><circle vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" /><circle class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="2" /></svg>
    </button>`;

const slickOptions = {
    accessibility: false,
    prevArrow: prevArrowHTML,
    nextArrow: nextArrowtHTML
};

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
        autoplay: false,
        fade:true
    });

    $('.sym-slides-single').slick({
        accessibility: true,
        fade:true
     });

    $('.sym-slides-columns').slick({
        accessibility: false,
        autoplay: false,
        arrows: true,
        dots: false,
        infinite: false,
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    
    $('.gallery_slider').slick({
        arrows: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 500,
        accessibility: true,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        infinite: true,
        appendArrows:$(".gallery-block__bottom_container .gallery-block__bottom--arrows")
    });

 
    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
    });

    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });


    /* Accordion */
	var accordionItems = document.querySelectorAll('.accordion__item');
	var i;
	for (i = 0; i < accordionItems.length; i++) {
		let disItem = accordionItems[i];
		let disBtn = disItem.querySelector('.accordion__btn');
		disBtn.addEventListener('click', function () {
			disItem.classList.toggle('open');
		});
	}


    //menus
    document.querySelectorAll('.js-menu-tab').forEach((btn) => {
        btn.addEventListener('click', _ => {
            $('.js-menu-tab.active').removeClass('active');
            $(btn).addClass('active');
            $('.quad-menus__menu-content.active').removeClass('active');
            var tabNumber = $(btn).attr('data-menuid');
            var tabToOpen = ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass('active');
            $('.quad-menus__tabs-image.active').removeClass('active');
            var imgToOpen = ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass('active');
            $('.name-bg.active').removeClass('active');
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass('active');
        });
    });

 let gallery = document.querySelectorAll('.gallery-block')[0]
if(gallery != undefined){

    let previewItem = gallery.previousElementSibling;
    if(previewItem.classList.contains('spa-information')){
        console.log(previewItem);
        document.querySelectorAll('.gallery-block')[0].classList.add('js-customIntroGallery');

    }
}
 console.log(gallery)



	//--------------


    // //script for show input when is mobile
	// const inputDate = document.querySelectorAll(".date input")[0];
	// if (inputDate != undefined) {
	// 	inputDate.addEventListener("click", function () {
	// 		if (this.getAttribute("type") === "date") {
	// 			this.showPicker();
	// 		}
	// 	});
	// }

})();